import { DEFAULT_PAGE_LIMIT } from 'utils/constants';
import httpClient from '../../httpClient';

export const updateIndividualValueForBusiness = (id, data) => {
  return httpClient({
    method: 'PUT',
    url: `/super-admin/businesses/${id}/update`,
    data,
  });
};

export const updateStatementDescriptor = (data) => {
  return httpClient({
    method: 'POST',
    url: `super-admin/stripe-account/update-statement-descriptor`,
    data,
  });
};

export const createNewBusiness = (data) => {
  return httpClient({
    method: 'POST',
    url: '/super-admin/businesses/create',
    data,
  });
};

export const getAllStoresForBusiness = (businessId) => {
  return httpClient({
    method: 'GET',
    url: `/super-admin/businesses/${businessId}/stores`,
  });
};

export const getLightweightStoresForBusiness = (businessId) => {
  return httpClient({
    method: 'GET',
    url: `/super-admin/businesses/${businessId}/stores/lightweight`,
  });
};

export const searchBusinesses = (
  searchInput,
  pageNumber = 0,
  limit = DEFAULT_PAGE_LIMIT,
  sortBy,
  sortOrder,
) => {
  return httpClient({
    method: 'GET',
    url: '/super-admin/businesses/all/search',
    params: {
      searchTerm: searchInput,
      limit,
      pageNumber: pageNumber + 1,
      sortBy,
      sortOrder,
    },
  });
};

export const getIndividualBusiness = (businessId) => {
  return httpClient({
    method: 'GET',
    url: `/super-admin/businesses/${businessId}/get`,
  });
};

export const updateIndividualValueForBusinessSettings = (data) => {
  return httpClient({
    method: 'PUT',
    url: `/super-admin/businesses/business/settings/update`,
    data,
  });
};

export const getAllThemesByBusinessId = (businessId) => {
  return httpClient({
    method: 'GET',
    url: `/super-admin/themes/${businessId}`,
  });
};

export const updateStoreTheme = (themeId, data) => {
  return httpClient({
    method: 'PATCH',
    url: `/super-admin/themes/store/${themeId}`,
    data,
  });
};

export const updateBusinessTheme = (themeId, data) => {
  return httpClient({
    method: 'PATCH',
    url: `/super-admin/themes/business/${themeId}`,
    data,
  });
};

export const updateThemesBunch = (data) => {
  return httpClient({
    method: 'PATCH',
    url: 'super-admin/themes/bunch',
    data,
  });
};

export const uploadLogo = (data) => {
  return httpClient({
    method: 'POST',
    url: `super-admin/themes/logo`,
    data,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const getAllFeatureFlagsForBusinessId = (businessId) => {
  return httpClient({
    method: 'GET',
    url: `/super-admin/businesses/${businessId}/flags`,
  });
};

export const updateLaunchDarklyFlag = ({ businessId, flagKey, value }) => {
  return httpClient({
    method: 'POST',
    url: `/super-admin/businesses/${businessId}/flags/${flagKey}`,
    data: {
      enabled: value,
    },
  });
};

export const getBusinessDistricts = (businessId) => {
  return httpClient({
    method: 'GET',
    url: `/super-admin/businesses/${businessId}/districts`,
  });
};

export const getBusinessTaxes = (businessId) => {
  return httpClient({
    method: 'GET',
    url: `/super-admin/businesses/${businessId}/taxes`,
  });
};

export const forceDudaSync = ({ businessId }) => {
  return httpClient({
    method: 'POST',
    url: `/super-admin/businesses/${businessId}/duda/sync`,
  });
};

export const getIntegrationsConfigs = (businessId) => {
  return httpClient({
    method: 'GET',
    url: `/super-admin/businesses/${businessId}/integrations/configs`,
  });
};

export const updateIntegrationsConfigs = ({
  businessId,
  webhookEndpoint,
  activeCampaignSiteId,
  activeCampaignAuthToken,
  activeCampaignFieldMappings,
}) => {
  return httpClient({
    method: 'PUT',
    url: `/super-admin/businesses/${businessId}/integrations/configs`,
    data: {
      webhookEndpoint,
      activeCampaignSiteId,
      activeCampaignAuthToken,
      activeCampaignFieldMappings,
    },
  });
};

export const fetchDevices = (businessId, params) => {
  return httpClient({
    method: 'GET',
    url: `super-admin/business-owners/${businessId}/devices`,
    params,
  });
};

export const fetchBatches = (businessId) => {
  return httpClient({
    method: 'GET',
    url: `super-admin/business-owners/${businessId}/batches`,
  });
};

export const fetchPayoutAccounts = (businessId) => {
  return httpClient({
    method: 'GET',
    url: `/super-admin/businesses/${businessId}/payout-accounts`,
  });
};

export const archivePayoutAccounts = ({ businessId, payoutAccountIds }) => {
  return httpClient({
    method: 'DELETE',
    url: `/super-admin/businesses/${businessId}/payout-accounts/archive`,
    data: {
      payoutAccountIds,
    },
  });
};

export const downloadStatementDescriptorsReport = () => {
  return httpClient({
    method: 'GET',
    url: `/super-admin/businesses/statement-descriptors/download`,
  });
};

export const acceptStripeTermsOfService = (data) => {
  return httpClient({
    method: 'POST',
    url: '/super-admin/businesses/payout-account/accept-tos',
    data,
  });
};

export const fetchMessengerConfiguration = (businessId) => {
  return httpClient({
    method: 'GET',
    url: `/super-admin/businesses/${businessId}/messenger-configuration`,
  });
};

export const updateMessengerConfiguration = (data, businessId) => {
  return httpClient({
    method: 'POST',
    url: `/super-admin/businesses/${businessId}/messenger-configuration`,
    data,
  });
};

export const calculateCustomerMetrics = (data, businessId) => {
  return httpClient({
    method: 'POST',
    url: `/super-admin/businesses/${businessId}/customers/metrics/calculation`,
    data,
  });
};

export const markBusinessAsChurned = (businessId) => {
  return httpClient({
    method: 'PUT',
    url: `/super-admin/businesses/${businessId}/churn`,
  });
};

export const markBusinessAsChurnReturn = (businessId) => {
  return httpClient({
    method: 'PUT',
    url: `/super-admin/businesses/${businessId}/churn-return`,
  });
};

export const activateBusiness = (businessId, data) => {
  return httpClient({
    method: 'POST',
    url: `/super-admin/businesses/${businessId}/activate`,
    data,
  });
};

export const handleBulkUploadOfDevices = (payload) => {
  const { businessId, devices, storeId } = payload;
  const data = {
    storeId,
    devices,
  };

  return httpClient({
    method: 'POST',
    url: `/super-admin/businesses/${businessId}/devices/bulk/create`,
    data,
  });
};
